import React from 'react';

const Contact: React.FC = () => {
  const contactInfo = [
    {
      title: 'EMAIL',
      value: 'info@teknura.com',
      icon: '✉'
    },
    {
      title: 'PHONE',
      value: '+880 1790 584634',
      icon: '📞'
    },
    {
      title: 'ADDRESS',
      value: 'Lohagara Par Chhatra, Lohagara, Narail, Bangladesh',
      icon: '📍'
    },
    {
      title: 'HOURS',
      value: 'Mon-Fri: 9AM-6PM EST',
      icon: '🕐'
    }
  ];

  return (
    <section id="contact" className="py-16 bg-bkash-bg">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-bkash-dark mb-4 border-b-2 border-bkash-red pb-2">
            GET IN TOUCH
          </h2>
          <p className="text-lg text-bkash-gray max-w-2xl mx-auto">
            Ready to transform your business with cutting-edge technology? 
            Let's discuss how we can help you achieve your goals.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* Contact Information */}
          <div className="bg-bkash-white border-2 border-bkash-red p-8 rounded-lg shadow-sm">
            <h3 className="text-2xl font-bold text-bkash-dark mb-8 text-center">
              CONTACT INFORMATION
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
              {contactInfo.map((info, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="text-3xl text-bkash-red flex-shrink-0">{info.icon}</div>
                  <div>
                    <h4 className="text-bkash-dark font-bold text-base mb-2">{info.title}</h4>
                    <p className="text-bkash-gray">{info.value}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Quick Response Notice */}
            <div className="bg-bkash-bg border-2 border-bkash-blue p-6 rounded-lg mb-8">
              <h4 className="text-xl font-bold text-bkash-blue mb-3 text-center">
                QUICK RESPONSE GUARANTEE
              </h4>
              <p className="text-bkash-dark text-center">
                We typically respond to all inquiries within 24 hours during business days. 
                For urgent matters, please call us directly.
              </p>
            </div>

            {/* Social Media */}
            {/* <div className="text-center">
              <h4 className="text-xl font-bold text-bkash-dark mb-4">
                FOLLOW US
              </h4>
              <div className="flex justify-center space-x-6">
                <a href="#" className="text-bkash-red hover:text-bkash-blue text-3xl transition-colors">
                  📘
                </a>
                <a href="#" className="text-bkash-red hover:text-bkash-blue text-3xl transition-colors">
                  🐦
                </a>
                <a href="#" className="text-bkash-red hover:text-bkash-blue text-3xl transition-colors">
                  💼
                </a>
                <a href="#" className="text-bkash-red hover:text-bkash-blue text-3xl transition-colors">
                  📷
                </a>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
